import React, { useRef } from "react";
import zoomout from './Assets/Icons/Zoomout.svg';
import zoomin from './Assets/Icons/ZoomIn.svg';

interface ZoomingProps {
    zoomLevel: number[];
    zoomIndex: number;
    setZoomIndex: React.Dispatch<React.SetStateAction<number>>;
}

const ZoomingSlider: React.FC<ZoomingProps> = ({ zoomLevel, zoomIndex, setZoomIndex }) => {
    const barRef = useRef<HTMLDivElement>(null);

    const handleDrag = (e: React.MouseEvent<HTMLDivElement>) => {
        try {
            e.preventDefault();
            const bar = barRef.current;
            if (!bar) return;

            const onMouseMove = (moveEvent: MouseEvent) => {
                const rect = bar.getBoundingClientRect();
                const moveX = moveEvent.clientX - rect.left;
                const stepWidth = rect.width / (zoomLevel.length - 1);
                const newStep = Math.round(moveX / stepWidth);

                if (newStep >= 0 && newStep < zoomLevel.length) {
                    setZoomIndex(newStep);
                }
            };

            const onMouseUp = () => {
                window.removeEventListener('mousemove', onMouseMove);
                window.removeEventListener('mouseup', onMouseUp);
            };

            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('mouseup', onMouseUp);
        } catch (error) {
            console.error("Error during drag operation:", error);
        }
    };

    const knobPositionPercent = zoomLevel[zoomIndex] === 50 ? 50 : (zoomIndex / (zoomLevel.length - 1)) * 100;

    return (
        <div className="tw-flex tw-py-3 tw-relative" style={{ zIndex: 2 }}>
            <div className="tw-flex tw-items-center tw-rounded-full tw-gap-1">
                <img src={zoomout} width={18} height={18} alt="Zoom out" className="tw-mr-2" />
                <div
                    ref={barRef}
                    className="tw-relative tw-rounded-full "
                    style={{ width: '5.25rem', height: '4px', backgroundColor: '#adafb3', cursor: 'pointer' }}
                >
                    <div
                        onMouseDown={handleDrag}
                        className="tw-absolute tw-rounded"
                        style={{
                            width: '1.25rem',
                            height: '1.25rem',
                            top: '50%',
                            left: `calc(${knobPositionPercent}% - 0.625rem)`,
                            transform: 'translateY(-50%)',
                            backgroundColor: '#24B2FF',
                            cursor: 'grab',
                            transition: 'left 0.3s ease-out',
                        }}
                    />
                </div>
                <img src={zoomin} width={18} height={18} alt="Zoom in" className="tw-ml-2 " />
                <span>{zoomLevel[zoomIndex] == 1 ? 0 : zoomLevel[zoomIndex]}%</span>
            </div>
        </div>
    );
};

export default ZoomingSlider;